<template lang="pug">
  #signUpIndex
    .container-width.p-3
      h5.text-center.font-weight-bold.mb-4 申請LINE個人化服務
      StepComponent(
        :stepArr="stepArr",
        :nowStep="nowStep"
      )
      #step1(v-if="nowStep == 1")
        .mb-4
          p 本服務限曾經在 {{ $companyName }} 授權百貨專櫃或官方網站留存資料之顧客申請使用。
        .text-area-scroll.mb-2
          .line-text-header
            .before-line
            code.title.font-weight-bold 使用須知
            .after-line
          .line-text-body.py-2.text-justify
            p 當日加入為 {{ $companyName }} 顧客者，須於顧客建檔完成的2~3個工作日後，方可申請LINE個人化服務。
            p 申請LINE官方帳號綁定服務時，{{ $companyName }} 將根據您提供的姓名及行動電話與LINE帳號進行身分驗證，
              | 本查詢及驗證服務於 {{ $companyName }} 執行，不會經由LINE紀錄資料。
            p 成功綁定個人化服務後，若更換手機或重新安裝LINE APP，
              code 需以原本LINE ID登入
              | 以利後續LINE個人化服務使用。
          .line-text-bottom
        b-form-checkbox.text-center.font-weight-bold.mb-3(
          id="agree"
          v-model="agree_status"
          name="agree"
          :value="true"
          :unchecked-value="false"
        ) 我已詳閱並同意相關使用須知
        .px-4
          button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
            @click="nextStepHandler()"
          )
            | 下一步
            i.fas.fa-arrow-alt-circle-right.fa-lg.arrorIcon
      #step2(v-if="nowStep == 2")
        .mb-4
          p 請輸入手機以便驗證
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="mobileNumberForm"
            tag="form"
            @submit.stop.prevent="mobileNumberHandler"
          )
            b-form-group.mb-0
              ValidationProvider(
                rules="required|mobile",
                ref="inputValMobileNumber",
                v-slot="{ errors }"
              )
                b-form-input(
                  id="mobileNumber",
                  type="text",
                  required,
                  trim,
                  :state="mobileState()",
                  v-model="userForm.mobile",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入行動電話 09XXXXXXXX"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span {{ errors[0] }}
        .px-4
          button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步
            i.fas.fa-arrow-alt-circle-right.fa-lg.arrorIcon
      #step3(v-if="nowStep == 3")
        .mb-4
          p 請輸入發送至您手機的驗證碼
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="mobileVerfityForm"
            tag="form"
            @submit.stop.prevent="mobileVerfityHandler"
          )
            b-form-group.mb-0
              ValidationProvider(
                rules="required",
                ref="inputValMobileVerfity"
              )
                b-form-input(
                  id="mobileVerfity",
                  type="text",
                  required,
                  trim,
                  :state="validverfityState()",
                  v-model="mobileVerfityCode",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入驗證碼"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 簡訊驗證碼不可為空
              .text-center
                button.btn.btn-remind.rounded-50.mt-2(
                  type="button",
                  @click="countDownHandler"
                )
                  div(
                    v-if="verfityNowTime == 0"
                  )
                    i.fas.fa-redo.fa-md.arrorIcon.pr-1
                    span 重發驗證碼
                  div(
                    v-else
                  ) {{ verfityNowTime }}秒後可重發驗證碼
        .px-4
          button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步
            i.fas.fa-arrow-alt-circle-right.fa-lg.arrorIcon
      #step4(v-if="nowStep == 4")
        .mb-4
          p 請輸入姓名及行動電話號碼以完成服務設定，
            code 您所輸入的資料需與留存於 {{ $companyName }} 系統的資料相同
            | 。
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="userForm"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValName"
              )
                label(
                  for="name"
                )
                  i.fas.fa-user.fa-lg.mx-1
                  code *
                  span 姓名
                .row
                  .col-6
                    b-form-input(
                      id="lastName",
                      type="text",
                      required,
                      trim,
                      :state="validState('lastName')",
                      v-model="userForm.lastName",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請輸入姓"
                    )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span 此欄不可為空
                  .col-6
                    b-form-input(
                      id="firstName",
                      type="text",
                      required,
                      trim,
                      :state="validState('firstName')",
                      v-model="userForm.firstName",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請輸入名"
                    )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span 此欄不可為空
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValSaCode"
              )
                label(
                  for="saCode"
                )
                  i.fas.fa-id-card.fa-lg.mx-1
                  code *
                  span 員工編號
                b-form-input(
                  id="code",
                  type="text",
                  required,
                  trim,
                  :state="validState('saCode')",
                  v-model="userForm.saCode",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入員工編號"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 此欄不可為空
            b-form-group
              ValidationProvider(
                rules="required|mobile",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                label(
                  for="mobile"
                )
                  i.fas.fa-mobile-alt.fa-lg.mx-1
                  code *
                  span 行動電話
                b-form-input(
                  id="mobile",
                  type="tel",
                  required,
                  trim,
                  :state="validState('mobile')",
                  v-model="userForm.mobile",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入行動電話",
                  :disabled="true"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span {{ errors[0] }}
            b-form-group
              ValidationProvider(
                rules="required|verify",
                ref="inputValVerify",
                v-slot="{ errors }"
              )
                label(
                  for="store"
                )
                  i.fas.fa-key.fa-lg.mx-1
                  code *
                  span 驗證碼
                .row.no-gutters
                  .col-md-8.col-6.pr-1.d-flex.align-items-center.flex-wrap
                    b-form-input.w-100(
                      id="verify",
                      type="text",
                      required,
                      trim,
                      :state="validState('verify')",
                      v-model="userForm.verify",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請輸入驗證碼"
                    )
                    b-form-invalid-feedback.w-100(
                      id="input-name-live-feedback"
                    )
                      span {{ errors.length === 0 ? '驗證碼錯誤' : errors[0] }}
                  .col-md-4.col-6.pl-1
                    .d-flex.align-items-center.justify-content-between
                      VerifyComponent(
                        ref="VerifyComponent"
                      )
                      i.fas.fa-sync-alt.fa-lg(
                        @click="changeVerifyCodeHandler"
                      )
        p.text-center.mb-3
          code *字號
          span 為必填選項，其餘選項皆為選填
        .px-4
          button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
            type="button",
            @click="nextStepHandler()"
          )
            | 送出資料
            i.fas.fa-arrow-alt-circle-right.fa-lg.arrorIcon

</template>

<script>
import StepComponent from '@/components/step/StepComponent.vue'; // 客製化進度條
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件
import { SA_SIGN_UP_SUCCESS } from '@/router/sa/sign-up';

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

// 客製化驗證套件
extend('verify', {
  validate: (val) => {
    if (VerifyComponent.data.varifyAnswer === undefined) return true;
    return val === VerifyComponent.data.varifyAnswer ? true : false;
  },
  message: '驗證碼錯誤'
});

export default {
  name: 'SaSignUpIndex',
  components: {
    StepComponent,
    ValidationProvider,
    ValidationObserver,
    VerifyComponent
  },
  data() {
    return {
      stepArr: [
        { title: '簽署同意書' },
        { title: '輸入手機號碼' },
        { title: '手機簡訊驗證' },
        { title: '輸入個人資料' }
      ],
      nowStep: 1,
      agree_status: false,
      firstType: true, // 第一次進來輸入資料
      userForm: {
        lastName: null,
        firstName: null,
        saCode: null,
        mobile: null,
        verify: null
      },
      mobileVerfityCode: null,
      verfityTotalTime: 180,
      verfityNowTime: 0,
      verfityCanClick: true
    };
  },
  mounted() {
    const vm = this;
    // 檢查綁定狀態
    vm.$store.dispatch('sa_sign_up/checkBindingHandler')
      .then(() => {
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    async nextStepHandler() {
      const vm = this;
      switch (vm.nowStep.toString()) {
      case '1':
        if (!vm.agree_status) {
          this.$swal.fire({
            icon: 'info',
            title: '請勾選同意事項'
          });
        } else {
          vm.nowStep = 2;
        }
        break;
      case '2':
        vm.mobileNumberHandler();
        break;
      case '3':
        vm.mobileVerfityHandler();
        break;
      case '4':
        vm.submitHandler();
        break;
      default:
        break;
      }
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await vm.$refs.userForm.validate();
      if (!isValid) {
        if (vm.userForm.lastName === null) {
          vm.userForm.lastName = '';
        }
        if (vm.userForm.firstName === null) {
          vm.userForm.firstName = '';
        }
        if (vm.userForm.saCode === null) {
          vm.userForm.saCode = '';
        }
        if (vm.userForm.mobile === null) {
          vm.userForm.mobile = '';
        }
        if (vm.userForm.verify === null) {
          vm.userForm.verify = '';
        }
        this.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        // 因為客製化驗證 extend 可以判斷是不是輸入一樣驗證碼但抓不到值，
        // 會造成畫面顯示正確卻一直跳到 isValid，所以改成手動驗證。
        if (vm.userForm.verify !== vm.$refs.VerifyComponent.varifyAnswer) {
          this.$swal.fire({
            icon: 'error',
            title: '請填妥必填欄位或格式輸入錯誤'
          });
          return;
        }
        this.$swal.fire({
          title: '表單送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        // 送出並綁定
        vm.$store.dispatch('sa_sign_up/doBindingHandler', {
          chinese_last_name: vm.userForm.lastName,
          chinese_first_name: vm.userForm.firstName,
          mobile: vm.userForm.mobile,
          sa_code: vm.userForm.saCode
        })
          .then(() => {
            this.$swal.close();
            vm.$router.push({
              name: SA_SIGN_UP_SUCCESS
            });
          });
      }
    },
    // 檢查有無填寫手機號碼
    async mobileNumberHandler() {
      const vm = this;
      const isValid = await vm.$refs.mobileNumberForm.validate();
      if (!isValid) {
        if (vm.userForm.mobile === null) {
          vm.userForm.mobile = '';
        }
        if (!vm.userForm.mobile) {
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫手機號碼'
          });
        }
      } else {
        vm.countDownHandler();
        vm.nowStep = 3;
      }
    },
    // 送出手機驗證
    async mobileVerfityHandler() {
      const vm = this;
      const isValid = await vm.$refs.mobileVerfityForm.validate();
      if (!isValid) {
        if (vm.mobileVerfityCode === null) {
          vm.mobileVerfityCode = '';
        }
        if (!vm.mobileVerfityCode) {
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫驗證碼'
          });
        }
      } else {
        vm.$swal.fire({
          title: '驗證中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        // 驗證簡訊驗證碼
        vm.$store.dispatch('sa_sign_up/validateSmsHandler', {
          mobile: vm.userForm.mobile,
          code: vm.mobileVerfityCode
        })
          .then(() => {
            this.$swal.close();
            vm.nowStep = 4;
          });
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.userForm[key]);
        }
        if (key === 'email') {
          const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
          return EmailReg.test(vm.userForm[key]);
        }
        if (key === 'verify') {
          return vm.userForm.verify === vm.$refs.VerifyComponent.varifyAnswer ? true : false;
        }
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    mobileState() {
      const vm = this;
      if (vm.userForm.mobile !== null) {
        const MobileReg = /^(09)[0-9]{8}$/;
        return MobileReg.test(vm.userForm.mobile);
      }
      return null;
    },
    validverfityState() {
      const vm = this;
      if (vm.mobileVerfityCode !== null) {
        return this.mobileVerfityCode ? true : false;
      }
      return null;
    },
    // 倒數驗證碼
    countDownHandler() {
      const vm = this;
      if (!vm.verfityCanClick) return;
      // 發送驗證碼
      vm.$store.dispatch('sa_sign_up/sendSmsValidateHandler', vm.userForm.mobile)
        .then(() => {
          vm.$snotify.success(null, '驗證碼已寄出');
          vm.verfityCanClick = false;
          vm.verfityNowTime = vm.verfityTotalTime;
          const clock = window.setInterval(() => {
            if (vm.verfityNowTime === 0) {
              window.clearInterval(clock);
              vm.verfityCanClick = true; // 這裡重新開啟
            } else {
              vm.verfityNowTime -= 1;
            }
          }, 1000);
        });
    },
    changeVerifyCodeHandler() {
      const vm = this;
      vm.$refs.VerifyComponent.changeVerifyCodeHandler();
    }
  }
};
</script>

<style>

</style>
